import { AnalyticsConfiguration, AnalyticsEvents, AnalyticsService } from './analytics.service';
import { Injectable, RendererFactory2 } from '@angular/core';
import { APP_VERSION, ANALYTICS_CONFIGURATION, ENV } from '../../core/constants';

declare let gtag: (...params: any[]) => void;
interface GoogleAnalyticsConfiguration extends AnalyticsConfiguration{
  googleAnalyticsTagId: string
}

@Injectable({providedIn: 'root'})
export class GoogleAnalyticsService extends AnalyticsService {

  constructor(rendererFactory: RendererFactory2) {
    super();
    const renderer = rendererFactory.createRenderer(null, null);

    const googleAnalyticsTagId = (ANALYTICS_CONFIGURATION as GoogleAnalyticsConfiguration).googleAnalyticsTagId;

    if(googleAnalyticsTagId != null) {
      try {

        const gtagScript = renderer.createElement('script');

        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + googleAnalyticsTagId;
        renderer.appendChild(document.head, gtagScript);

        const gtagFunctionScript = renderer.createElement('script');
        gtagFunctionScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '` + googleAnalyticsTagId + `', {'send_page_view': false, 'anonymize_ip': true });
      `;
        renderer.appendChild(document.head, gtagFunctionScript);

      } catch(ex) {
        console.error('Error appending google analytics');
        console.error(ex);
      }
    }
  }

  public createEvent(key: AnalyticsEvents, params = {}): void {
      gtag('event', key, {...params, 'env': ENV, 'version': APP_VERSION});
  }
}
